export const CAMPAIGN_SETTLEMENT_KEYS = {
  all: ["campaignSettlement"] as const,
  lists: () => [...CAMPAIGN_SETTLEMENT_KEYS.all, "list"] as const,
  list: (campaignId: string) =>
    [...CAMPAIGN_SETTLEMENT_KEYS.lists(), campaignId] as const,
  details: () => [...CAMPAIGN_SETTLEMENT_KEYS.all, "detail"] as const,
  detail: (campaignId: string, influencerId: string) =>
    [...CAMPAIGN_SETTLEMENT_KEYS.details(), campaignId, influencerId] as const,
};
